<template>
  <div class="quick-sign-in-content-two-container">
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="vp-pos-absolute vp-left-406 vp-top--8"
      @click="$bvModal.hide('quickSignIn')"
    >
      <path
        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
        fill="#F46A6A"
      />
    </svg>

    <div class="d-flex justify-content-center vp-width-363">
      <div class="spinner-container">
        <b-spinner
          v-if="!areaChecksLoaded && !!area"
          variant="secondary"
          role="status"
          size="sm"
          class="quick-sign-in-loader"
        />
      </div>

      <p
        class="vp-font-weight-700 vp-font-size-17 line-height-20_4 vp-mb-24 vp-height-12"
      >
        {{ $t('users.form.quickSignin') }}
      </p>
    </div>

    <p
      class="vp-font-weight-700 vp-font-size-16 text-center line-height-19_2 vp-mb-40 vp-color-grey-2 vp-height-12"
    >
      {{ $t('common.signInOut') }}
    </p>

    <UserCheckIn
      parentGrid="quickSignIn"
      :isNewUser="isNewUser"
      :existingUserInfo="existingUserInfo"
      :newUserInfo="newUserInfo"
      :key="incrementOnAreaChange"
      @setWizardButtonValue="setWizardButtonValue"
      @userCheckinFormInvalid="userCheckinFormInvalid"
      @areaChecksDone="areaChecksDone"
      />
  </div>
</template>

<script>
import sitesService from "@/services/sites";
import UserCheckIn from "@/components/sharedCells/userAction/UserCheckinAction.vue";

export default {
  components: {
    UserCheckIn,
  },
  props: {
    isNewUser: {
      type: Boolean,
    },
    existingUserInfo: {
      type: Object,
    },
    newUserInfo: {
      type: Object,
    },
  },
  data() {
    return {
      sitesOptions: [],
      areasOptions: [],
      site: null,
      area: null,
      loadingFlow: false,
      showSiteAndArea: true,
      incrementOnAreaChange: 0,
      isUserSignedIn: false,
      areaChecksLoaded: false,
      areaStatus: null,
      attendanceModeErrMsg: "",
      siteErrMsg: "",
    };
  },
  methods: {
    setWizardButtonValue(areaLoginMode,isSignedIn) {
      let wizardButtonValue = "";
      switch (areaLoginMode) {
        case "checkIn_only":
          wizardButtonValue = "CHECK IN";
          break;
        case "signIn_signOut":
          wizardButtonValue = isSignedIn ? "SIGN OUT" : "SIGN IN";
          break;
      }
      this.$emit("setAreaLoginMode", wizardButtonValue);
    },
    userCheckinFormInvalid(isInvalid) {
      this.$emit("userCheckinFormInvalid", isInvalid);
    },
    areaChecksDone(){
      this.areaChecksLoaded = true; 
    },
    onSubmit() {
      this.$emit("signInOutFormSubmitted", true);
    },
  },
  watch: {
    site() {
      this.areasOptions = this.site.areas;
      this.area = this.areasOptions.length == 1 ? this.areasOptions[0] : null;
    },
    siteErrMsg(errMsg) {
      if (errMsg) this.area = null;
    },
    area() {
      this.incrementOnAreaChange++;
    },
  },
  async beforeMount() {
    try {
      const { data: sites } = await sitesService.getSitesWithAreasInEntity();
      //Set site if there is only one site available
      if (sites?.length == 1) this.site = sites[0];
      this.sitesOptions = sites;
    } catch (error) {
      console.error("Could not fetch entity sites ", error);
    }
  },
  destroyed() {
    this.showSiteAndArea = true;
  },
};
</script>

<style lang="scss">
.quick-sign-in-content-two-container {
  width: 416px;
  .spinner-container {
    width: 54px;
    text-align: center;
  }
  .quick-sign-in-loader {
    width: 17px;
    height: 17px;
    margin: 0;
  }
}
</style>
